export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_REDIRECT = "AUTH_REDIRECT";
export const AUTH_INIT = "AUTH_INIT";

export const API_START = "API_START";
export const API_SUCCESS = "API_SUCCESS";
export const API_FAIL = "API_FAIL";
export const CLEAR_ERROR = "CLEAR_ERROR";

export const SET_SIGN_UP_DATA = "SET_SIGN_UP_DATA";
export const SET_LOGIN_DATA = "SET_LOGIN_DATA";

export const REMOVE_VALIDATIONS = "REMOVE_VALIDATIONS";

export const VALIDATE_SIGNUP = "VALIDATE_SIGNUP";
export const VALIDATE_LOGIN = "VALIDATE_LOGIN";
export const VALIDATE_FOROGOT_PASSWORD = "VALIDATE_FOROGOT_PASSWORD";
export const VALIDATE_RESET_PASSWORD = "VALIDATE_RESET_PASSWORD";

export const VALIDATE_PERSONALINFO = "VALIDATE_PERSONALINFO";
export const VALIDATE_PRACTICEDETAILS = "VALIDATE_PRACTICEDETAILS";
export const VALIDATE_DOCUMENTS = "VALIDATE_DOCUMENTS";
export const VALIDATE_SIGNATURE = "VALIDATE_SIGNATURE";
export const VALIDATE_SUBSCRIPTION = "VALIDATE_SUBSCRIPTION";

export const VERIFY_EMAIL = "VERIFY_EMAIL";

export const SET_PERSONAL_INFO = "SET_PERSONAL_INFO";
export const SET_PRACTICE_DETAILS = "SET_PRACTICE_DETAILS";
export const SET_DOCUMENTS = "SET_DOCUMENTS";
export const SET_PERSONALISE_EXPERIENCE = "SET_PERSONALISE_EXPERIENCE";

export const ADD_SLOTS = "ADD_SLOTS";
export const SET_SLOTS = "SET_SLOTS";
export const REMOVE_SLOTS = "REMOVE_SLOTS";
export const ADD_WORKING_DAYS = "ADD_WORKING_DAYS";
export const ADD_ACCEPT_UNTIL = "ADD_ACCEPT_UNTIL";

export const ADD_CALENDAR = "ADD_CALENDAR";
export const REMOVE_CALENDAR = "REMOVE_CALENDAR";

export const GET_NOTIFICATIONS_INFO = "GET_NOTIFICATIONS_INFO";
export const UPDATE_NOTIFICATIONS_STATUS = "UPDATE_NOTIFICATIONS_STATUS";
export const DELETE_NOTIFICATIONS = "DELETE_NOTIFICATIONS";
export const MARK_ALL_NOTIFICATIONS_READ = "MARK_ALL_NOTIFICATIONS_READ";
export const UPDATE_NOTIFICATION_STATE = "UPDATE_NOTIFICATION_STATE";

export const HANDLE_PCP_REQUEST = "HANDLE_PCP_REQUEST";

export const SET_CHANGE_PASSWORD = "SET_CHANGE_PASSWORD";
export const VALIDATE_CHANGE_PASSWORD = "VALIDATE_CHANGE_PASSWORD";
export const CLEAR_CHANGE_PASSWORD = "CLEAR_CHANGE_PASSWORD";

export const SET_AVAILABILITY_SCHEDULE = "SET_AVAILABILITY_SCHEDULE";
export const VALIDATE_AVAILABILITY_SCHEDULE = "VALIDATE_AVAILABILITY_SCHEDULE";
export const SET_UNAVAILABILITY_SCHEDULE = "SET_UNAVAILABILITY_SCHEDULE";

//APPOINTMENTS
export const SET_REQUESTS_APPOINTMENTS = "SET_REQUESTS_APPOINTMENTS";
export const ACCEPT_APPOINTMENTS = "ACCEPT_APPOINTMENTS";
export const SET_APPOINTMENT_DATA = "SET_APPOINTMENT_DATA";
export const REMOVE_APPOINTMENT_DATA = "REMOVE_APPOINTMENT_DATA";

export const RESET_APPOINTMENT_DETAIL = "RESET_APPOINTMENT_DETAIL";
export const RESET_REQUESTED_APPOINTMENT = "RESET_REQUESTED_APPOINTMENT";

//Patients
export const SET_PATIENTS = "SET_PATIENTS";
export const SET_PATIENT_PROFILE = "SET_PATIENT_PROFILE";
export const GET_PATIENT = "GET_PATIENT";
export const SET_PATIENT_PERSONAL_INFO = "SET_PATIENT_PERSONAL_INFO";

export const ADD_ALLERGIES = "ADD_ALLERGIES";
export const REMOVE_ALLERGIES = "REMOVE_ALLERGIES";
export const UPDATE_ALLERGIES = "UPDATE_ALLERGIES";
export const ADD_MEDICAL_CONDITION = "ADD_MEDICAL_CONDITION";
export const REMOVE_MEDICAL_CONDITION = "REMOVE_MEDICAL_CONDITION";
export const ADD_MEDICATION = "ADD_MEDICATION";
export const SET_MEDICATION = "SET_MEDICATION";
export const REMOVE_MEDICATION = "REMOVE_MEDICATION";
export const ADD_PREVIOUS_SURGERY = "ADD_PREVIOUS_SURGERY";
export const SET_PREVIOUS_SURGERY = "SET_PREVIOUS_SURGERY";
export const REMOVE_PREVIOUS_SURGERY = "REMOVE_PREVIOUS_SURGERY";
export const ADD_FAMILY_MEDICAL_HISTORY = "ADD_FAMILY_MEDICAL_HISTORY";
export const REMOVE_FAMILY_MEDICAL_HISTORY = "REMOVE_FAMILY_MEDICAL_HISTORY";
export const ADD_CURRENT_MEDICATION_TIME = "ADD_CURRENT_MEDICATION_TIME";
export const ADD_MEDICATION_TIME = "ADD_MEDICATION_TIME";
export const SET_MEDICAL_RECORD = "SET_MEDICAL_RECORD";
export const ADD_MEDICAL_RECORD = "ADD_MEDICAL_RECORD";
export const REMOVE_MEDICAL_RECORD = "REMOVE_MEDICAL_RECORD";
export const SET_CONTACT_DETAILS = "SET_CONTACT_DETAILS";
export const ADD_CONTACT_DETAILS = "ADD_CONTACT_DETAILS";
export const REMOVE_CONTACT_DETAILS = "REMOVE_CONTACT_DETAILS";

export const VALIDATE_PATIENT_PERSONAL_INFO = "VALIDATE_PATIENT_PERSONAL_INFO";
export const VALIDATE_PATIENT_DOCUMENT_INFO = "VALIDATE_PATIENT_DOCUMENT_INFO";
export const VALIDATE_PATIENT_CONTACT_INFO = "VALIDATE_PATIENT_CONTACT_INFO";
export const VALIDATE_PATIENT_DOSESPOT_PROFILE =
    "VALIDATE_PATIENT_DOSESPOT_PROFILE";

export const SEARCH_PATIENT = "SEARCH_PATIENT";
export const GET_PATIENT_NOTES = "GET_PATIENT_NOTES";
export const EDIT_PATIENT_NOTES = "EDIT_PATIENT_NOTES";
export const SEARCH_PATIENT_NOTES = "SEARCH_PATIENT_NOTES";
export const EMPTY_PATIENT_DATA = "EMPTY_PATIENT_DATA";
export const SET_CURRENT_NOTE_IMAGES = "SET_CURRENT_NOTE_IMAGES";
export const SET_CURRENT_NOTE_DATA = "SET_CURRENT_NOTE_DATA";
export const CLEAR_CURRENT_NOTE_DATA = "CLEAR_CURRENT_NOTE_DATA";
export const SET_PATIENT_FILES = "SET_PATIENT_FILES";
export const SEARCH_PATIENT_FILES = "SEARCH_PATIENT_FILES";
export const EMPTY_PATIENT_FILES = "EMPTY_PATIENT_FILES";
export const EMPTY_PATIENT_LIST = "EMPTY_PATIENT_LIST";

export const SET_PATIENT_PRESCRIPTIONS = "SET_PATIENT_PRESCRIPTIONS";
export const SEARCH_PATIENT_PRESCRIPTIONS = "SEARCH_PATIENT_PRESCRIPTIONS";
export const EMPTY_PATIENT_PRESCRIPTIONS = "EMPTY_PATIENT_PRESCRIPTIONS";

//Note Templates
export const ADD_TEMPLATE = "ADD_TEMPLATE";
export const VALIDATE_TEMPLATE = "VALIDATE_TEMPLATE";
export const SET_TEMPLATE_DATA = "SET_TEMPLATE_DATA";
export const CLEAR_TEMPLATE_DATA = "CLEAR_TEMPLATE_DATA";
export const SET_ALL_TEMPLATE = "SET_ALL_TEMPLATE";
export const GET_TEMPLATE_BYID = "GET_TEMPLATE_BYID";
export const UPDATE_TEMPLATE_BYID = "UPDATE_TEMPLATE_BYID";
export const SET_EDIT_MODE = "SET_EDIT_MODE";
export const CLEAR_EDIT_MODE = "CLEAR_EDIT_MODE";
export const REMOVE_TEMPLATE_BYID = "REMOVE_TEMPLATE_BYID";
export const UPDATE_ALL_TEMPLATE_DATA = "UPDATE_ALL_TEMPLATE_DATA";
export const EMPTY_TEMPLATE_DATA = "EMPTY_TEMPLATE_DATA";
export const SEARCH_TEMPLATE_DATA = "SEARCH_TEMPLATE_DATA";
export const SET_CURRENT_ID = "SET_CURRENT_ID";
export const SET_SCREENSHOTS = "SET_SCREENSHOTS";
export const CLEAR_SCREENSHOTS = "CLEAR_SCREENSHOTS";
export const DELETE_SCREENSHOT = "DELETE_SCREENSHOT";
export const SET_IMAGES_INSIDE_NOTES = "SET_IMAGES_INSIDE_NOTES";
export const REMOVE_IMAGES_FROM_NOTES = "REMOVE_IMAGES_FROM_NOTES";

export const SET_VIEW_MODE = "SET_VIEW_MODE";

export const CHANGE_CONTROL = "CHANGE_CONTROL";
export const CLEAR_CONTROL = "CLEAR_CONTROL";
export const SET_NUDGE_PERMISSION = "SET_NUDGE_PERMISSION";

//settings
export const ALL_BLOCKED_PATIENTS = "ALL_BLOCKED_PATIENTS";
export const EMPTY_BLOCKED_PATIENTS = "EMPTY_BLOCKED_PATIENTS";
export const GET_CURRENT_DOCTOR = "GET_CURRENT_DOCTOR";
export const CHANGE_CURRENT_LOCATION = "CHANGE_CURRENT_LOCATION";
export const GET_CURRENT_LOCATION = "GET_CURRENT_LOCATION";
export const GET_PAYMENT_HISTORY = "GET_PAYMENT_HISTORY";
export const REMOVE_PAYMENT_HISTORY = "REMOVE_PAYMENT_HISTORY";

//ongoing appointment
export const SET_ONGOINGAPPOINTMENT_DATA = "SET_ONGOINGAPPOINTMENT_DATA";
export const SET_CHAT = "SET_CHAT";
export const REMOVE_ONGOINGAPPOINTMENT_DATA = "REMOVE_ONGOINGAPPOINTMENT_DATA";
export const SET_PHYSICIANS = "SET_PHYSICIANS";
export const REMOVE_SHARED_DOCUMENTS = "REMOVE_SHARED_DOCUMENTS";
export const REMOVE_PARTICIPANTS = "REMOVE_PARTICIPANTS";
export const SET_SHARED_FILES = "SET_SHARED_FILES";

export const SET_VISIT_NOW = "SET_VISIT_NOW";
export const CLEAR_CHAT = "CLEAR_CHAT";
export const CHAT_NOTIFICATION_MESSAGE = "CHAT_NOTIFICATION_MESSAGE";

// account  details
export const SET_ACCOUNT_DETAILS = "SET_ACCOUNT_DETAILS";
export const SET_BANK_DETAILS = "SET_BANK_DETAILS";
export const REMOVE_BANK_DETAILS = "REMOVE_BANK_DETAILS";

export const VALIDATE_ACH_BANK_DETAILS = "VALIDATE_ACH_BANK_DETAILS";

// earning-reports
export const SET_EARNING_REPORTS = "SET_EARNING_REPORTS";
export const SEARCH_EARNING_REPORTS = "SEARCH_EARNING_REPORTS";
export const EMPTY_EARNING_REPORTS = "EMPTY_EARNING_REPORTS";

// Concierge service
export const SET_SUBSCRIBED_CONCIERGE_SERVICE_LIST = "SET_SUBSCRIBED_CONCIERGE_SERVICE_LIST";
export const SET_CLEAR_MESSSAGE_NOTIFICATION_DOT = "SET_CLEAR_MESSSAGE_NOTIFICATION_DOT";
export const SET_CHAT_MESSAGES_COUNT = "SET_CHAT_MESSAGES_COUNT";
export const SET_ACTIVE_PATIENT_SUBSCRIPTION_COUNT = "SET_ACTIVE_PATIENT_SUBSCRIPTION_COUNT";
export const SET_CONCIERGE_SERVICE_STATUS = "SET_CONCIERGE_SERVICE_STATUS";